import { render } from "./inactive-account.vue?vue&type=template&id=9e920554&ts=true"
import script from "./inactive-account.vue?vue&type=script&lang=ts"
export * from "./inactive-account.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__